import { IconName } from "./icons";

// =============================================================================
// PortalLayout — navigation config
// -----------------------------------------------------------------------------
// Plain data describing the sidebar nav. Decoupled from the legacy redux-driven
// `constants/menu.ts` (which carries CASL permissions, service-id gating and the
// dual-variant custom icons) — this is the migration starting point, so it is
// intentionally simple. Routes mirror the live portal so links resolve.
//
// To wire real permission/service filtering later, map `constants/menu.ts` into
// this shape (or pass a filtered `nav` prop into <PortalLayout/>).
// =============================================================================

export interface NavItem {
  key: string;
  label: string;
  to: string;
  icon: IconName;
  /** Optional count badge (e.g. unread requests). */
  badge?: number | string;
  /** Marks an item with children; submenu rendering is a TODO for the template. */
  hasChildren?: boolean;
}

export interface NavSection {
  key: string;
  title: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    key: "main",
    title: "Main Menu",
    items: [
      { key: "dashboard", label: "Dashboard", to: "/dashboard", icon: "dashboard" },
      { key: "requests", label: "Requests", to: "/supplier/available-requests", icon: "requests" },
      { key: "offers", label: "Offers", to: "/supplier/offers", icon: "offers" },
      { key: "invoices", label: "Invoices", to: "/supplier/invoices", icon: "invoices" },
    ],
  },
  {
    key: "inventory",
    title: "Inventory",
    items: [
      { key: "aircrafts", label: "Aircrafts", to: "/supplier/aircrafts", icon: "aircraft", hasChildren: true },
    ],
  },
  {
    key: "help",
    title: "Help",
    items: [
      { key: "support", label: "Support", to: "/supplier/support", icon: "support" },
      { key: "messages", label: "Messages", to: "/supplier/chat", icon: "messages" },
      { key: "documentation", label: "Documentation", to: "/supplier/documentation", icon: "documentation" },
      { key: "settings", label: "Settings", to: "/supplier/settings", icon: "settings" },
    ],
  },
];
